import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
// routes
import { Link } from "react-router-dom";
import Title from "../Title";
import Axios from "axios";

// import Header from "../../survey/survey-form/landing-page/widgets/Header";
import Svg from "../../../../component/Svg";

import { toast } from 'react-toastify';


export const ResetPassword = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const [passwordConfirmType, setPasswordConfirmType] = useState('password');


  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };


  const [newpassword, setNewPassword] = useState('');
  const [renewpassword, setReNewPassword] = useState('');
  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get('email');
  //console.log("email", email)

  React.useEffect(() => {
    if (email == null) {
      window.location = '/ForgotPassword';
    }
  });

  const setPassword = () => {
    if (newpassword == renewpassword) {
      Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/changePassword", {
        new_password: newpassword,
        user_email: email

      }).then((response) => {
        //console.log(response.status)
        if (response.status === 200) {
          //alert("Password changed successful!");
          toast.success("Password Changed Successfully!");
          window.location = '/admin/password-changed/?email=' + email;

        } else {
          // alert("Try Again, something went wrong!");
          toast.error("Try Again, something went wrong!")
        }
      });

    }
    else {
      alert("Password Didn't matched!");
    }

  };

  function viewPassword(e) {
    if (passwordType === "password") {
      setPasswordType("text");
    } 
    else {
      setPasswordType("password");
    }
  }
  function viewPasswordConfirm(e) {
    if (passwordConfirmType === "password") {
      setPasswordConfirmType("text");
    } 
    else {
      setPasswordConfirmType("password");
    }
  }


  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>

        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <div className="logo-wrap text-center">
                <Link to="/#0t" className='home-logo'>
                  <Svg name="logo" />
                </Link>
              </div>
              <div className="form-wrapper">
                <div className="form-heading text-center">
                  <h3>Reset password</h3>
                  <p>Your new password must be different from previously used passwords.</p>
                </div>
                <div className="field-wrapper">
                  <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}

                    <Input
                      type={passwordType}
                      view="outlined"
                      color="default"
                      label=""
                      placeholder="Enter new password"
                      fill
                      className={"formsinput"}
                      name="newpassword"
                      value={newpassword}
                      onInput={e => setNewPassword(e.target.value)}
                    />
                    <div className="password-requirement">
                      <p>Requirements</p>
                      <ul>
                        <li className="invalid">Minimum of 6 characters</li>
                        <li className="invalid">Contains an uppercase letter</li>
                        <li className="valid">Contains a number (0-9)</li>
                        <li className="valid">Contains special characters (!@#$%&*.)</li>
                      </ul>
                    </div>
                    <span className={"forgot-wrap " + passwordType} onClick={viewPassword}>
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                    <Input
                      type={passwordConfirmType}
                      view="outlined"
                      color="default"
                      label=""
                      placeholder="Confirm password"
                      fill
                      className={"formsinput"}
                      name="renewpassword"
                      value={renewpassword}
                      onInput={e => setReNewPassword(e.target.value)}
                    />
                    
                    <span className={"forgot-wrap " + passwordConfirmType} onClick={viewPasswordConfirm}>
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    </span>
                  </div>

                </div>
                <div className="button-wrap">
                  <Button className={"formsbutton btn btn-primary"}
                    type="default"
                    view="filled"
                    color="primary"
                    text="Set new password"
                    fill={true}
                    onClick={setPassword}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
